import type { FC, SVGProps } from 'react';
import { ChipWrapper, Label } from './FilterChip.styles';

interface FilterChipProps {
  label: string;
  icon: FC<SVGProps<SVGElement>>;
}

export const FilterChip: FC<FilterChipProps> = ({ label, icon: Icon }) => {
  return (
    <ChipWrapper>
      <Icon />
      <Label>{label}</Label>
    </ChipWrapper>
  );
};
